/**
 * Created by lu on 2018/4/3.
 */
var nb = require('../../nb');
var getSearchKeywords = require('../../io/' + process.env.APP_ENV + '/getSearchKeywords');
module.exports = nb.define({
    parent: nb.Model,
    mapping: {
        input: nb.Model,
        list: nb.model.List
    },
    method: {
        init: function () {
            this.set('list',{
                itemType:require('../../view/header/KeywordItem')
            });
            this.onChange('requireSearch', function (inEvent,inValue) {
                if(inValue){
                    this.getSearchKeywords(inValue);
                }else {
                    this.setOpts({
                        list:{
                            items:[]
                        },
                        active:''
                    });
                }
            }, this);
        },
        getSearchKeywords: function (inValue) {
            getSearchKeywords({
                data: {
                    textContent: inValue
                },
                scope: this,
                success: function (inResp) {
                    var items = [];
                    $.each(inResp ||[],function (inIndex,inItem) {
                        items[inIndex] = {
                            text:inItem
                        }
                    });
                    this.setOpts({
                        list:{
                            items:items
                        }
                    });
                    if(items.length>0){
                        this.set('active','active');
                    }else {
                        this.set('active','');
                    }
                }
            });
        }
    }
});


//////////////////
// WEBPACK FOOTER
// ../src/js/model/header/SearchBox.js
// module id = 43
// module chunks = 0 1 2 3 4 5 6 7 8 9 10 11 12 13 14 15 16 17 18 19 20 21 22 23 24 25 26 27 28 29 30 31 32